module.exports = __webpack_public_path__ + "fontawesome-webfont.woff2";